import type { Id } from '../../aliases'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type ResponseHeader = {
  messageType: number
  messageId: Id
  status: number
  statusMessage?: string
}

export const ResponseHeaderSchema: CborSchema<ResponseHeader> =
  defineCborSchema<ResponseHeader>({
    messageType: CborField({ key: 0 }),
    messageId: CborField({ key: 1 }),
    status: CborField({ key: 2 }),
    statusMessage: CborField({ key: 3, required: false }),
  })
